<template>
    <div ref="two_bar"></div>
</template>

<script>
import TwoBar from "!!raw-loader!../../assets/ricoh_assets/icons/ICN002-09_two_bar.svg" // loads SVG Icons as String via Webpack.
export default {
    mounted() {
        let shadowRoot = this.$refs.two_bar.attachShadow({mode: 'open'})
        shadowRoot.innerHTML = TwoBar

        const style = document.createElement('style')
        style.innerHTML = `svg { width: 100%; height: 100%; }`

        const clonedStyle = style.cloneNode(true)
        shadowRoot.appendChild(clonedStyle)
    }
}
</script>

<style>
</style>